import { createContext } from "react"

const InstanceContext = createContext();

export default InstanceContext;